module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_3-57fe68d033c80948f1d8ff4198943733.png";